/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { 
  styled,
  Card,
  Typography,
  Button,
  Menu,
 } from "@mui/material";
 import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';

export const StyledHeaderContainer = styled('div')({
  height: '50px',
  width: '100%',
  boxShadow:'rgba(0, 0, 0, 0.02) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '5px 0px',
})

export const StyledCard = styled(Card)({
  display: "flex",
  flexDirection: "row",
  height: "50px !important",
  borderRadius: "15px",
  marginRight: '15px'
})

export const LoaderContainer = styled('div')({
  height: '90%',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex'
})

export const StyledTitle = styled(Typography)({
  textAlign: 'center',
  fontSize: '29px',
  fontWeight: '600',
})

export const StyledSubTitle = styled(Typography)({
  fontSize: '20px',
  textAlign: 'center',
  marginTop: '10px',
})

export const StyledContentText = styled(Typography)({
  textAlign: 'center',
})

export const NavbarActions = styled(Card)({
  display: "flex",
  flexDirection: "row",
  height: "50px !important",
  gap: '2%',
  alignItems: 'center',
})

export const StyledUserButton = styled(Button)({
  '&:hover': {
    backgroundColor: '#f0f0f0',
    color: '#282828'
  },
  textTransform: 'none',
  color: '#727272',
  padding: '12px 15px 10px 15px',
  borderRadius: '10px',
  fontSize: '14px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

export const StyledAccountIcon = styled(AccountCircleOutlinedIcon)({
  fontSize: '30px !important',
  marginTop: '-4px !important',
})

export const StyledMenu = styled(Menu)({
  '& .MuiPaper-root': {
    borderRadius: '10px', 
    boxShadow: 'rgba(0, 0, 0, 0.14) 0px 3px 8px !important',
    minWidth: '10%'
  }
});

export const pageContainerStyle = {
  overflowY: 'scroll',
  overflowX: 'hidden',
};

export const brandLogoStyle = {
  width: '270px',
  height: '100%',
};

export const userButtonContainerStyle = {
  marginRight: '20px',
};

export const contentContainerStyle = {
  marginTop: '30vh',
};

export const welcomeTextStyle = {
  marginTop: '5px',
};
